import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Container,
} from "@material-ui/core";
import { NavLink } from "react-router-dom";
import GitHubIcon from "@material-ui/icons/GitHub";
import * as Constants from "../../Constants/Styles";

const Navbar = (props) => {
  const classes = Constants.useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="relative" color="secondary">
        <Container>
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="open drawer">
              <GitHubIcon></GitHubIcon>
            </IconButton>
            <Typography className={classes.title} variant="h6" noWrap>
              {props.title}
            </Typography>
            <Button color="inherit">
              <NavLink to="/" className={classes.navLink}>
                Home
              </NavLink>
            </Button>
            <Button color="inherit">
              <NavLink to="/about" className={classes.navLink}>
                About
              </NavLink>
            </Button>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};

export default Navbar;
